import React from "react";

function Reasons() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#7a7c7f"
        d="M404.64 191.649h-66.614a7.726 7.726 0 110-15.452h66.614c7.864 0 14.262-6.398 14.262-14.262V79.981a7.726 7.726 0 1115.452 0v81.953c0 16.385-13.33 29.715-29.714 29.715z"
        data-original="#dbe8f9"
      ></path>
      <path
        fill="#ac80dd"
        d="M425.46 65.078V24.174c0-11.312-7.4-20.892-17.622-24.174H388.62c-13.65 0-24.716 11.066-24.716 24.716v39.82c0 13.65 11.066 24.716 24.716 24.716h19.217c10.222-3.281 17.623-12.861 17.623-24.174z"
        data-original="#ac80dd"
      ></path>
      <path
        fill="#9d66d5"
        d="M464.636 0h-67.474c13.65 0 24.716 11.066 24.716 24.716v39.82c0 13.65-11.066 24.716-24.716 24.716h67.474c13.65 0 24.716-11.066 24.716-24.716v-39.82C489.352 11.066 478.286 0 464.636 0z"
        data-original="#9d66d5"
      ></path>
      <path
        fill="#7a7c7f"
        d="M256 137.454a7.726 7.726 0 01-7.726-7.726V79.981a7.726 7.726 0 1115.452 0v49.746a7.726 7.726 0 01-7.726 7.727z"
        data-original="#dbe8f9"
      ></path>
      <path
        fill="#db636e"
        d="M254.831 65.078V24.174c0-11.312-7.4-20.892-17.622-24.174h-19.217c-13.65 0-24.716 11.066-24.716 24.716v39.82c0 13.65 11.066 24.716 24.716 24.716h19.217c10.222-3.281 17.622-12.861 17.622-24.174z"
        data-original="#db636e"
      ></path>
      <path
        fill="#d84a54"
        d="M294.008 0h-67.474c13.65 0 24.716 11.066 24.716 24.716v39.82c0 13.65-11.066 24.716-24.716 24.716h67.474c13.65 0 24.716-11.066 24.716-24.716v-39.82C318.724 11.066 307.658 0 294.008 0z"
        data-original="#d84a54"
      ></path>
      <path
        fill="#7a7c7f"
        d="M166.462 191.649H107.36c-16.385 0-29.714-13.33-29.714-29.715V79.981a7.726 7.726 0 1115.452 0v81.953c0 7.864 6.398 14.262 14.262 14.262h59.101c4.267 0 7.726 3.459 7.726 7.726s-3.458 7.727-7.725 7.727z"
        data-original="#dbe8f9"
      ></path>
      <path
        fill="#ffe07d"
        d="M84.203 65.078V24.174c0-11.312-7.4-20.892-17.622-24.174H47.364c-13.65 0-24.716 11.066-24.716 24.716v39.82c0 13.65 11.066 24.716 24.716 24.716h19.217c10.222-3.281 17.622-12.861 17.622-24.174z"
        data-original="#ffe07d"
      ></path>
      <path
        fill="#ffd064"
        d="M123.38 0H55.906c13.65 0 24.716 11.066 24.716 24.716v39.82c0 13.65-11.066 24.716-24.716 24.716h67.474c13.65 0 24.716-11.066 24.716-24.716v-39.82C148.096 11.066 137.03 0 123.38 0z"
        data-original="#ffd064"
      ></path>
      <path
        fill="#fff"
        d="M110.032 38.548h-24.66a7.726 7.726 0 110-15.452h24.66a7.726 7.726 0 110 15.452zm0 27.609H60.711a7.726 7.726 0 110-15.452h49.321a7.726 7.726 0 110 15.452zm170.629 0h-49.322a7.726 7.726 0 110-15.452h49.322a7.726 7.726 0 110 15.452zm0-27.609H256a7.726 7.726 0 110-15.452h24.661a7.726 7.726 0 110 15.452zm170.628 0h-24.661a7.726 7.726 0 110-15.452h24.661a7.726 7.726 0 110 15.452zm0 27.609h-49.321a7.726 7.726 0 110-15.452h49.321a7.726 7.726 0 110 15.452z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#f9eae2"
        d="M256 442.056c23.849 0 61.801-63.65 54.434-65.068l-5.385-2.847a21.365 21.365 0 01-11.38-18.888v-51.892h-75.338v51.892c0 7.918-4.38 15.187-11.38 18.888l-5.385 2.847c-7.367 1.418 30.584 65.068 54.434 65.068z"
        data-original="#f9eae2"
      ></path>
      <path
        fill="#f9eae2"
        d="M264.402 332.341c15.027-13.208 23.294-32.598 23.636-52.707l-.227-98.367c-.375-4.578 1.785-20.213-6.437-35.703-7.344-1.415-15.096-2.115-23.013-2.17-39 .607-74.249 16.485-74.07 59.461l.06 14.407.025 6.027-4.805.003c-10.693.005-19.356 8.679-19.349 19.372l.013 17.555c.008 10.689 8.678 19.349 19.367 19.344l4.97-.002c.502 19.772 8.79 38.77 23.675 51.632 7.953 6.873 18.052 13.136 30.417 16.629 10.256-3.788 18.82-9.4 25.738-15.481z"
        data-original="#f9eae2"
      ></path>
      <path
        fill="#f5dbcc"
        d="M351.714 236.199c-.031-7.525-6.083-13.599-13.517-13.567l-5.071.022-.085-20.434c-.151-36.183-25.41-53.025-56.875-57.54 4.83 7.976 7.615 17.798 7.665 29.726l.241 104.519c-.337 19.776-8.467 38.843-23.244 51.832-7.08 6.223-15.892 11.968-26.528 15.687 7.411 2.591 15.699 4.205 24.926 4.27 22.17-.345 38.915-9.5 50.812-19.957 14.777-12.989 22.907-32.057 23.244-51.832l5.091-.022c7.434-.032 13.435-6.157 13.404-13.682z"
        data-original="#f5dbcc"
      ></path>
      <path
        fill="#9bc4f9"
        d="M291.152 385.218l-.501-.209c-26.554 15.128-60.869 11.513-83.7-10.867s-23.633 3.132-50.65 14.64c-45.475 19.371-74.857 64.192-74.857 113.621 0 5.3 4.297 9.597 9.597 9.597h55.507s3.459-8.595 7.726-8.595S162 512 162 512h188s3.459-8.595 7.726-8.595 7.726 8.595 7.726 8.595h3.733a10.182 10.182 0 001.737-5.702c0-52.674-31.31-100.438-79.77-121.08z"
        data-original="#9bc4f9"
      ></path>
      <path
        fill="#7fb2f9"
        d="M355.699 388.782c-27.017-11.508-50.65-14.64-50.65-14.64a69.91 69.91 0 01-19.521 13.515c.895.366 1.794.74 2.697 1.125 45.475 19.371 74.857 64.192 74.857 113.621 0 5.3-4.297 9.597-9.597 9.597h67.474c5.3 0 9.597-4.297 9.597-9.597 0-49.429-29.381-94.25-74.857-113.621z"
        data-original="#7fb2f9"
      ></path>
      <path
        fill="#407093"
        d="M280.179 183.169a39.436 39.436 0 017.633-1.641l-.001-.262c-.394-4.812 2.021-21.84-7.772-38.075-5.308-8.795-13.061-15.385-22.391-20.089h-37.015c-33.514 0-60.682 27.168-60.682 60.682v40.102c0 5.89 3.728 11.135 9.29 13.073l14.947 5.204c5.225 1.819 10.681-2.065 10.672-7.597l-.033-28.278c-.057-13.752 10.91-24.948 24.496-25.006l.296-.002a39.32 39.32 0 0112.2 1.89c6.961 2.237 24.179 3.562 24.179 3.562s17.22-1.326 24.181-3.563z"
        data-original="#407093"
      ></path>
      <path
        fill="#365e7d"
        d="M291.367 123.101h-41.249c19.836 8.461 33.601 24.623 33.713 51.304l.018 7.785a39.253 39.253 0 018.531-.911l.296.002c13.586.058 24.554 11.254 24.496 25.006l-.033 28.278c-.009 5.532 5.447 9.416 10.672 7.597l14.947-5.204a13.842 13.842 0 009.29-13.073v-40.102c0-33.513-27.168-60.682-60.681-60.682z"
        data-original="#365e7d"
      ></path>
      <path
        fill="#7fb2f9"
        d="M162 512v-32.46a7.726 7.726 0 10-15.452 0V512zm195.726-40.186A7.726 7.726 0 00350 479.54V512h15.452v-32.46a7.725 7.725 0 00-7.726-7.726z"
        data-original="#7fb2f9"
      ></path>
    </svg>
  );
}

export default Reasons;